import request from '@/api/request'

export default {
  async getOrderShippingMethods () {
    return (await request.get(`module/action/erp/flexy/order_shipping_method/retrieve`)).data
  },
  async getOrderPaymentMethods () {
    return (await request.get(`module/action/erp/flexy/order_payment_method/retrieve`)).data
  },
  async getShoppingStores () {
    return (await request.get(`module/action/erp/flexy/shopping_store/retrieve`)).data
  }
}



// WEBPACK FOOTER //
// ./src/api/erp/flexy/index.js